module.exports = __webpack_public_path__ + "static/media/reta.d5556964.png";